import { type ReactNode } from 'react'
import { Scrollbars } from 'react-custom-scrollbars-2'

const renderNoScroll = () => <span />

type Props = {
  children: ReactNode
  className?: string
  minHeight?: number | string
  maxHeight?: number | string
  hideHorizontalScrollBar?: boolean
  autoHeight?: boolean
}

const ContentScrollbars = ({
  children,
  className,
  minHeight = 10,
  maxHeight = '60vh',
  hideHorizontalScrollBar,
  autoHeight = true,
}: Props) => {
  return (
    <Scrollbars
      autoHeight={autoHeight}
      autoHeightMin={minHeight}
      autoHeightMax={maxHeight}
      className={className}
      renderTrackHorizontal={hideHorizontalScrollBar ? renderNoScroll : undefined}
    >
      {children}
    </Scrollbars>
  )
}

export default ContentScrollbars
